import React, {Component} from 'react';
import {connect} from 'react-redux';
import {actions} from "../actions";
import {BrowserRouter, Route} from 'react-router-dom';

import './App.css';

import Header from './Header';
import Navigation from './Navigation';

import {BASENAME} from "../constants";

import Assessments from './assessments/Assessments';
import NewAssessmentDashboard from './assessments/NewAssessmentDashboard';
import Home from './Home';
import Login from './Login';
import Assessment from './assessments/Assessment';
import Reports from './reports/Reports';
import Forbidden from './Forbidden';
import CoordinatorManagement from "./users/CoordinatorManagement";
import CoordinatorNew from "./users/CoordinatorNew";
import Reviews from './reviews/Reviews';
import Rubrics from './rubric/RubricDashboard';
import Review from './reviews/Review';
import LinkerHelper from './helpers/linker/LinkerDashboard'
import LoadingBar from "./parts/LoadingBar";

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: process.env.REACT_APP_BUTTON_COLOR||"#cc0000",
            contrastText: process.env.REACT_APP_BUTTON_TEXT_COLOR||'#fff'
        },
        secondary: {
            main: process.env.REACT_APP_BUTTON_COLOR||"#cc0000",
            contrastText:  process.env.REACT_APP_BUTTON_TEXT_COLOR||'#fff'
        }
    },
    typography: {
        useNextVariants: true,
    }
});

class App extends Component {

    async componentDidMount() {
        this.props.fetchUser();
    }

    renderRouting() {
        return(
            <div className='main' 
            style={{
                '--main-body-text-color' :process.env.REACT_APP_MAIN_BODY_TEXT_COLOR,
                '--page-background-color':process.env.REACT_APP_PAGE_BACKGROUND_COLOR
            }}>
                <Route exact path="/" component={Home}></Route>
                <Route exact path="/login" component={Login}></Route>
                <Route exact path="/rubrics" component={Rubrics}></Route>
                <Route exact path="/assessments/new" component={NewAssessmentDashboard}></Route>
                <Route exact path="/assessments" component={Assessments}></Route>
                <Route exact path="/curriculummap" component={LinkerHelper}></Route>
                <Route exact path="/assessment/:assessment_id" component={Assessment}/>
                <Route exact path="/reviews" component={Reviews}></Route>
                <Route exact path="/review/:assessment_id" component={Review}/>
                <Route exact path="/reports" component={Reports}></Route>
                <Route path="/forbidden" component={Forbidden}/>
                <Route exact path="/users" component={CoordinatorManagement}></Route>
                <Route exact path="/users/new" component={CoordinatorNew}></Route>
            </div>
        );
    }

    render() {
        document.body.style = `background: ${process.env.REACT_APP_PAGE_BACKGROUND_COLOR}`;
        return (
            <BrowserRouter basename={BASENAME}>
                <MuiThemeProvider theme={theme}>
                    <Header/>
                    <Navigation/>
                    <LoadingBar/>
                    {this.renderRouting()}
                </MuiThemeProvider>
            </BrowserRouter>
        );
    }

}

export default connect(null, actions)(App);
